module.exports = __webpack_public_path__ + "img/elec_inner_pic1.dcf494b0.png";